module.exports = __webpack_public_path__ + "media/images/app/homepage/diamonds-desktop-068817b135772b3d5c0b764b51550b74.webp";